import React from 'react'

export type RoleType = 'owner' | 'auditor' | 'security' | 'user'

interface RoleLabelProps {
  role: RoleType | string
  text: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const getRoleStyles = (role: string) => {
  switch (role) {
    case 'owner':
      return 'bg-purple-100 text-purple-800 border border-purple-200'
    case 'auditor':
      return 'bg-amber-100 text-amber-800 border border-amber-200'
    case 'security':
      return 'bg-red-100 text-red-800 border border-red-200'
    case 'user':
      return 'bg-blue-100 text-blue-800 border border-blue-200'
    default:
      return 'bg-gray-100 text-gray-800 border border-gray-200'
  }
}

const getSizeClasses = (size: 'sm' | 'md' | 'lg') => {
  switch (size) {
    case 'sm':
      return 'px-2 py-0.5 text-xs'
    case 'md':
      return 'px-3 py-1 text-sm'
    case 'lg':
      return 'px-4 py-1.5 text-base'
    default:
      return 'px-3 py-1 text-sm'
  }
}

export default function RoleLabel({ role, text, size = 'md', className = '' }: RoleLabelProps) {
  const roleStyles = getRoleStyles(role)
  const sizeClasses = getSizeClasses(size)

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${roleStyles} ${sizeClasses} ${className}`}>
      {text}
    </span>
  )
}